import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { TRANSCRIPT_ENDPOINT_URL } from '../../../common/constants/request';

import logger from '../../../common/helpers/logger';
import { tmPostRequest } from '../../../common/helpers/request';
import {
  errorTranscriptAction,
  getTranscriptAction,
  setLoadingStateAction,
  setTranscriptAction,
} from '../slices/transcripts';

export default (action$) =>
  action$.pipe(
    ofType(getTranscriptAction.type),
    mergeMap(({ payload }) => {
      const stream$ = tmPostRequest({
        url: TRANSCRIPT_ENDPOINT_URL,
        body: {
          videoId: payload.videoId,
          ccLanguage: payload.lang,
        },
      }).pipe(
        switchMap(({ response }) => {
          const segments = response?.segments ?? [];

          return concat(of(setLoadingStateAction(false)), of(setTranscriptAction(segments)));
        }),
        catchError((error) => {
          logger.error('modules/PlayerOverview/redux/epics/getTranscript', error);

          return concat(of(setLoadingStateAction(false)), of(errorTranscriptAction()));
        }),
      );

      return concat(of(setLoadingStateAction(true)), stream$);
    }),
  );
